<template>
  <form @submit.prevent="submit" :class="errorClass">
    <rp-textinput
      v-model="resource.filter"
      :placeholder="userMessage(userType)"
      :error="filterError"
      @input="touch('filter')"/>
    <rp-button :disabled="isInvalid" type="primary">Search</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'

  export default {
    name: 'UserLookupForm',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput
    },

    props: {
      userType: {
        type: String,
        required
      }
    },

    computed: {
      ...errorMessages(['filter'])
    },

    validations: {
      resource: {
        filter: {required}
      }
    },

    methods: {
      userMessage(type) {
        if(type === 'patient') {
          return `Search ${type} by email or by ID`
        }
        return `Search ${type} by email`
      }
    },
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/UserLookup.vue